import React from 'react';

/* eslint-disable max-len */
const FashionIcon = _ref => {
  let {
    className,
    title
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", {
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: "32",
    height: "32",
    viewBox: "0 0 32 32",
    fill: "none"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("path", {
    d: "M29.0591 25.5486H2.94075C1.53595 25.5486 0.444746 24.7806 0.166346 23.5902C-0.0736539 22.5726 0.329546 21.0302 2.25275 20.0702C2.85755 19.7694 4.40315 19.0046 6.26875 18.0862C9.78875 16.3422 14.6431 13.955 16.2079 13.1614C17.5583 12.4734 17.9519 10.8062 17.6447 9.51015C17.5487 9.11975 17.1519 7.84615 15.9679 7.84615C15.7379 7.82627 15.5061 7.85255 15.2863 7.92343C15.0665 7.99432 14.8631 8.10839 14.6879 8.25895C14.2399 8.71015 14.2431 9.46535 14.2431 9.71495V9.75335C14.2431 9.94006 14.169 10.1191 14.0369 10.2512C13.9049 10.3832 13.7259 10.4574 13.5391 10.4574C13.3524 10.4574 13.1734 10.3832 13.0413 10.2512C12.9093 10.1191 12.8351 9.94006 12.8351 9.75335V9.72135C12.8351 8.66535 13.1167 7.83975 13.6895 7.26695C13.9913 6.98245 14.3477 6.76227 14.7372 6.6198C15.1267 6.47732 15.541 6.41552 15.9551 6.43815C17.4303 6.43815 18.5951 7.49095 19.0015 9.18375C19.4079 10.8766 18.9279 12.9982 17.3119 14.131C19.6383 15.3086 23.4847 17.1166 26.4031 18.4894C27.9903 19.2414 29.2351 19.8398 29.7599 20.083C31.6799 21.043 32.0863 22.5726 31.8463 23.603C31.5551 24.7806 30.4639 25.5486 29.0591 25.5486Z",
    fill: "#323254"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8143 14.9473C13.7023 16.0001 9.84312 17.9201 6.89272 19.3601C5.02712 20.2817 3.48472 21.0401 2.87992 21.3441C1.69272 21.9329 1.41432 22.7489 1.53592 23.2641C1.65752 23.7793 2.20152 24.1377 2.94072 24.1377H29.0591C29.7983 24.1377 30.3391 23.8177 30.4639 23.2641C30.5887 22.7105 30.3071 21.9297 29.1199 21.3441C28.6207 21.0945 27.3823 20.5121 25.8175 19.7761C22.4927 18.2145 17.9711 16.0897 15.8143 14.9473Z",
    fill: "white"
  }));
};

export { FashionIcon };
